import { useCallback } from 'react';
import { Platform } from 'react-native';

const useDynamicFontSize = () => {
    const calculateFontSize = useCallback(fontSize => {
        if (!Platform.OS === 'web') {
            return fontSize;
        }

        return Platform.OS.equals('web') ? `${Math.floor(fontSize * 0.068)}rem` : Math.floor(fontSize * 0.068);
    }, []);

    return {
        calculateFontSize
    };
};

export default useDynamicFontSize;
